module.exports = __webpack_public_path__ + "img/sketch-white-end.228a80f3.png";